import { z } from 'zod';
import { verificationIdentifierGuard } from '../interactions.js';
import { VerificationType } from './verification-type.js';
export const passwordVerificationRecordDataGuard = z.object({
    id: z.string(),
    type: z.literal(VerificationType.Password),
    identifier: verificationIdentifierGuard,
    verified: z.boolean(),
});
